var _path, _path2, _path3, _g, _path4, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 94,
    viewBox: "0 0 84 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9053_58781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint0_linear_9053_58781)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9053_58781)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint1_linear_9053_58781)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "#F2AA50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 36.4219,
    x2: 61.4557,
    y2: 36.4219,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 45.5776,
    x2: 61.4557,
    y2: 45.5776,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 54.7332,
    x2: 61.4557,
    y2: 54.7332,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 63.8896,
    x2: 61.4557,
    y2: 63.8896,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5439,
    y1: 73.0453,
    x2: 61.4557,
    y2: 73.0453,
    stroke: "white",
    strokeWidth: 12
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9053_58781",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 94
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2059 94H6.79412C3.04183 94 0 90.9939 0 87.2857V6.71429C0 3.00609 3.04183 0 6.79412 0H52.5L84 31.1299V87.2857C84 90.9939 80.9582 94 77.2059 94Z",
    fill: "url(#paint2_linear_9053_58781)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9053_58781)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: -8.49258,
    cy: -1.9842,
    rx: 69.0221,
    ry: 65.4643,
    fill: "url(#paint3_linear_9053_58781)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: -8.49213,
    cy: -1.98353,
    rx: 43.3897,
    ry: 41.0487,
    fill: "url(#paint4_linear_9053_58781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7148 77.9999L35.4488 59.2019H39.4528L46.1738 77.9999H42.3908L40.8568 73.6449H34.0968L32.5238 77.9999H28.7148ZM34.9418 70.3299H39.9468L37.4638 62.8679L34.9418 70.3299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3965 59.2019H53.1795V77.9999H49.3965V59.2019Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9053_58781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 31.1299H74.5C62.3497 31.1299 52.5 21.2801 52.5 9.12988V0L84 31.1299Z",
    fill: "#CC9249"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9053_58781",
    x: 29.5,
    y: -24,
    width: 81.5,
    height: 81.1299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9053_58781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9053_58781",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9053_58781",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9053_58781",
    x1: 0,
    y1: 0,
    x2: 96.4083,
    y2: 78.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34A0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85C894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9053_58781",
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E85567"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9053_58781",
    x1: -3.48108,
    y1: 0.265432,
    x2: 17.0213,
    y2: 55.3258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9053_58781",
    x1: -5.34172,
    y1: -0.57292,
    x2: 7.48934,
    y2: 33.9735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.a26e6ff5dfdc58eae43c3a56c1a05348.svg";
export { ForwardRef as ReactComponent };